import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿En qué formato recibo el sistema?',
    answer: 'PDF descargable. Acceso inmediato después del pago desde cualquier dispositivo.'
  }, {
    question: '¿Necesito experiencia previa?',
    answer: 'No. Está diseñado para el ciclista amateur de 35 a 55 años que sale los fines de semana. Si salís con un grupo y querés rendir más, este sistema es para vos.'
  }, {
    question: '¿Está adaptado a Argentina?',
    answer: 'Sí. Productos, rutas, precios y marcas disponibles en Argentina. Sin traducciones ni adaptaciones.'
  }, {
    question: '¿Y si no me sirve?',
    answer: 'Tenés 7 días de garantía total. Si no notás diferencia, te devolvemos el 100% sin preguntas.'
  }];
  return <section className="bg-gray-900 text-white py-16 px-4" data-id="element-42">
      <div className="max-w-3xl mx-auto" data-id="element-43">
        <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-44">
          PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-45">
          {faqs.map((faq, index) => <div key={index} className="bg-gray-800 border border-gray-700 rounded-lg overflow-hidden" data-id="element-46">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-750 transition-colors" data-id="element-47">
                <span className="font-semibold text-lg" data-id="element-48">{faq.question}</span>
                <ChevronDownIcon className={`w-5 h-5 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-49" />
              </button>
              {openIndex === index && <div className="px-6 py-4 bg-gray-850 border-t border-gray-700" data-id="element-50">
                  <p className="text-gray-300" data-id="element-51">{faq.answer}</p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}